export const GLOBAL_Client_URL = 'https://localhost:7290/api/admin'; 
//export const GLOBAL_Client_Api_URL = 'https://localhost:7003'; 
export const GLOBAL_Client_Api_URL = 'https://map.manafith.net.sa'; 
export const GLOBAL_ShopNo = 4018; 
export interface Option {
  value: string;
  label: string;
}

export interface Option {
  value: string;
  label: string;
}
